import React, { Component } from "react"
import { Arwes, Frame as FrameC, Words } from "arwes"
import styled from "styled-components"
import { signIn } from "./redux/reducers"
import { connect } from "react-redux"
import SignIn from "./SignIn"
import {
  ContentColumn,
  PageBlock,
  PageOffset
} from "../../common/styled/Page"

const Container = styled.div`
  margin-top: 100px;

  @media (max-width: 900px) {
    margin-top: 24px;
  }
`

const ErrorPanel = styled.div`
  margin-top: 24px;

  @media (max-width: 900px) {
    margin-top: 16px;
  }
`

const ErrorMessage = styled.div`
  padding: 20px;

  @media (max-width: 600px) {
    padding: 16px;
  }
`

class SignInContainer extends Component {
  handleSubmit = (values) => {
    this.props.signIn(values)
  }
  render() {
    const { user, isExpanded } = this.props
    return (
      <Arwes>
        <PageOffset isExpanded={isExpanded}>
          <Container>
            <ContentColumn maxWidth={680}>
              <PageBlock>
                <SignIn onSubmit={this.handleSubmit} />
                {user && user.loaded === "error" && (
                  <ErrorPanel>
                    <FrameC animate level={3} corners={3} layer={"alert"}>
                      <ErrorMessage>
                        <Words animate layer="alert">
                          Error has occurred, please try again
                        </Words>
                      </ErrorMessage>
                    </FrameC>
                  </ErrorPanel>
                )}
              </PageBlock>
            </ContentColumn>
          </Container>
        </PageOffset>
      </Arwes>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  }
}

export default connect(mapStateToProps, { signIn })(SignInContainer)
